import { render, staticRenderFns } from "./ListUserIntegrationSettings.vue?vue&type=template&id=9655b72e&scoped=true&"
import script from "./ListUserIntegrationSettings.vue?vue&type=script&lang=js&"
export * from "./ListUserIntegrationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9655b72e",
  null
  
)

export default component.exports